import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Header, FieldName, FieldValue } from '../_local/styles'
import Pencil from '@material-ui/icons/Edit'
import ContactInfoDialog from '../_local/modals/ContactInfoDialog'
import { getContactInfoFields } from '../service'
import { Button, Box } from '@material-ui/core'

const ContactInfoRow = (props) => {
  const { address, id, legacyFreelancerId, personalSummary, phone, setPropChange } = props
  const [open, setOpen] = useState(false)
  const { address1, address2, zipCode, region, city } = address
  const { paroReferrer, referrerOther } = personalSummary

  const contactInfo = {
    address1,
    address2,
    zipCode,
    region,
    city,
    phone,
    paroReferrer,
    referrerOther,
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Contact Info</Header>
        </Grid>

        <Grid item>
          <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
            Edit
          </Button>
        </Grid>
      </Grid>

      <Box style={{ width: '75%' }}>
        <Grid container spacing={5}>
          {Object.entries(contactInfo).map((field, index) => {
            const formattedFields = getContactInfoFields(field)

            return (
              <Grid item key={index}>
                <FieldName>{formattedFields?.label}</FieldName>
                <FieldValue>{formattedFields?.value}</FieldValue>
              </Grid>
            )
          })}
        </Grid>
      </Box>

      <ContactInfoDialog
        open={open}
        handleClose={handleClose}
        setPropChange={setPropChange}
        data={{ ...contactInfo, expertId: id, legacyFreelancerId }}
      />
    </>
  )
}

export default ContactInfoRow
